import React from 'react';
import ReactDOM from 'react-dom';

const PopUpDialog = React.forwardRef((props, ref) => {
  const {
    children,
    className,
    onClickOutside,
    show = false,
    ...other } = props;

  return show && ReactDOM.createPortal(
    <div className="popup-dialog__overlay">
      <div
        ref={ref}
        className={`popup-dialog ${className}`}
        {...other}
      >
        {children}
      </div>
    </div>,
    document.body
  );
});

export default PopUpDialog;
